import { render, staticRenderFns } from "./PortalDesignerPermissions.vue?vue&type=template&id=8e3a9696&"
import script from "./PortalDesignerPermissions.vue?vue&type=script&lang=js&"
export * from "./PortalDesignerPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e3a9696')) {
      api.createRecord('8e3a9696', component.options)
    } else {
      api.reload('8e3a9696', component.options)
    }
    module.hot.accept("./PortalDesignerPermissions.vue?vue&type=template&id=8e3a9696&", function () {
      api.rerender('8e3a9696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pageDesigner/PortalDesignerPermissions.vue"
export default component.exports